import React, { Fragment, useEffect, useState, forwardRef } from "react";
import { useAuth } from "../context/AuthContext";
import { AxisDate } from "../util/AxisDateTime";
import AsyncSelect from "react-select/async";

const DropDownTimesheetWeekSelection = forwardRef(({
  onSelected,
  defaultSelect = null,
  useCurrentTimesheetWeekending = false,
  disabled = false,
}, ref) => {
  const { authAxios } = useAuth();
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(defaultSelect);
  const [offset, setOffset] = useState(0);
  const [fetchCount, setFetchCount] = useState(15);

  const getLabel = (week) => {
    return AxisDate(week?.weekEnding);
  };

  useEffect(() => {
    if (defaultSelect?.id === null || defaultSelect?.id === undefined) return;

    setSelected({ value: defaultSelect, label: getLabel(defaultSelect) });
  }, [defaultSelect]);

  const fetch = async (search) => {
    try {
      setLoading(true);

      const config = {
        headers: {
          "content-type": "application/json",
        },
        params: {},
      };
      const pageSettings = {
        direction: "dsc",
        key: "weekEnding",
        page: offset,
        elementPerPage: fetchCount,
      };
      const response = await authAxios().post(
        "/api/backoffice/timesheet/timesheet_weeks_paging",
        pageSettings,
        config,
      );

      const data = response?.data?.content?.map((week) => {
        return { value: week, label: getLabel(week) };
      });

      setLoading(false);

      return data;
    } catch (error) {
      setLoading(false);
      console.log("Error catch");
      console.log(error);
      console.log(error.stack);
    }
    return [];
  };

  const selectTimesheetWeek = (week) => {
    setSelected(week);
    onSelected(week?.value);
  };

  const promiseOptions = (inputValue) =>
    new Promise((resolve) => {
      setTimeout(() => {
        resolve(fetch(inputValue));
      }, 1000);
    });

  // Expose methods to the parent component via ref
  React.useImperativeHandle(ref, () => ({
    reset: () => {
      setSelected(null);
      onSelected(null);
    }
  }));

  return (
    <Fragment>
      <AsyncSelect
        className={"fs-input"}
        cacheOptions
        loadOptions={promiseOptions}
        defaultOptions={true}
        isClearable={true}
        onChange={(data) => {
          selectTimesheetWeek(data);
        }}
        value={selected}
        placeholder={"Select Week"}
        isDisabled={disabled}
        isSearchable={false}
      />
    </Fragment>
  );
});

export default DropDownTimesheetWeekSelection;
